<template>
  <div class="bid-action-column">
    <WdsMenu
      z-index="50"
      placement="bottom-end"
      manual-trigger
      :global="tableGlobals"
    >
      <template #trigger="{ toggle }">
        <WdsButtonGhost @click="toggle">
          <WdsIcon name="overflow-menu-horizontal" :size="16" />
        </WdsButtonGhost>
      </template>

      <WdsMenuOption :href="jobPath">
        <WdsIcon :size="16" :name="WdsIconNameEnum.VIEW" />
        {{ $t('View job') }}
      </WdsMenuOption>

      <WdsMenuOption v-if="conversationUrl" :href="conversationUrl">
        <WdsIcon :size="16" :name="WdsIconNameEnum.CHAT" />
        {{ $t('View conversation') }}
      </WdsMenuOption>
    </WdsMenu>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import {
  WdsButtonGhost,
  WdsIcon,
  WdsIconNameEnum,
  WdsMenu,
  WdsMenuOption,
} from '@worksome/wds-components'
import { FragmentType, graphql, useFragment } from '@/gql'
import { laravelNamedRoute } from '@/utils/laravelNamedRoutes'
import { $t } from '@/app-bootstrapping/SetUpInternationalization'
import { useTableGlobalsSelector } from '@/components/GraphqlDataTable/injection'

const tableGlobals = useTableGlobalsSelector()

const frag = graphql(`
  fragment BidActionColumn on Bid {
    id
    job {
      id
    }
    conversation {
      id
      url
    }
  }
`)

const props = defineProps<{ row: FragmentType<typeof frag> }>()
const column = computed(() => useFragment(frag, props.row))

const jobPath = computed(() => laravelNamedRoute('jobs.show', { job: column.value?.job.id }))

const conversationUrl = computed(() => column.value?.conversation?.url)
</script>

<style scoped lang="scss">
.bid-action-column {
  :deep(.wds-menu) {
    width: max-content;
  }
}
</style>
